import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useCreateBusCharterMutation,
  useUpdateReservationMutation,
} from "../../../../store/api/school/ReservationSlice";
import OneTime from "./OneTime";
import Recurring from "./Recurring";
import { formatDateToYMD } from "../../../../utils/dateAndTimeConversion";

const BusCharter = ({
  onClose,
  selectedVehicle = null,
  selectedReservation = null,
}) => {
  const { t } = useTranslation();
  // vendor id if exist
  const { id } = useParams();

  const [bookingType, setBookingType] = useState("one_time");

  // Create New Driver query
  const [createBusCharter, { isLoading }] = useCreateBusCharterMutation();
  const [updateReservation, { isLoading: isUpdateLoading }] =
    useUpdateReservationMutation();

  const handleSubmit = async (data) => {
    const payload = {
      charter_frequency: bookingType,
      ...data,
      ...(id && { vendor_id: id, transfer_to_vendor: 1 }),
      vehicle_id: selectedVehicle?.id,
      start_date: formatDateToYMD(data.start_date),
      end_date: data.end_date ? formatDateToYMD(data.end_date) : null,
    };

    try {
      let response;
      selectedReservation?.id && selectedReservation
        ? (response = await updateReservation({
            data: payload,
            id: selectedReservation?.id,
          }).unwrap())
        : (response = await createBusCharter(payload).unwrap());

      if (response.statusCode === 200 || response.statusCode === 201) {
        toast.success(response.message);
        onClose();
      }
    } catch (err) {
      const mesg = err.data?.message || "Something went wrong";
      toast.error(mesg);
    }
  };

  useEffect(() => {
    if (selectedReservation) {
      setBookingType(selectedReservation?.charter_frequency || "one_time");
    }
  }, [selectedReservation]);

  return (
    <>
      <div
        className="popupBox p-4"
        style={{ maxHeight: "90vh", overflowY: "auto" }}
      >
        <div className="mb-2 p-2">
          <label className="me-4">
            <span className="radioWrapper">
              <input
                className="radioInpt"
                type="radio"
                value="one_time"
                name="bookingType"
                id="one_time"
                checked={bookingType === "one_time"}
                onChange={(e) => setBookingType(e.target.value)}
              />
              <i className="bg"></i>
            </span>{" "}
            {t("one")} {t("time")}
          </label>
          <label>
            <span className="radioWrapper">
              <input
                className="radioInpt"
                type="radio"
                value="recurring"
                name="bookingType"
                id="recurring"
                checked={bookingType === "recurring"}
                onChange={(e) => setBookingType(e.target.value)}
              />
              <i className="bg"></i>
            </span>{" "}
            {t("recurring")}
          </label>
        </div>
        <div aria-hidden={bookingType !== "one_time" ? true : false}>
          {/* One Time Bus Charter Reservation */}
          <OneTime
            onClose={onClose}
            selectedVehicle={selectedVehicle}
            selectedReservation={selectedReservation}
            isLoading={isLoading || isUpdateLoading}
            onSubmit={handleSubmit}
          />
        </div>
        <div aria-hidden={bookingType !== "recurring" ? true : false}>
          {/* Recurring Bus Charter Reservation */}
          <Recurring
            onClose={onClose}
            selectedVehicle={selectedVehicle}
            selectedReservation={selectedReservation}
            isLoading={isLoading || isUpdateLoading}
            onSubmit={handleSubmit}
          />
        </div>
      </div>

      <style>{`
        .modal-dialog {
          max-width: 600px;
        }


        .address,
        .address:focus,
        .select__control--is-focused,
        .select__control--menu-is-open,
        .css-13cymwt-control,
        .css-13cymwt-control:hover,
        .css-t3ipsp-control:hover {
          padding: 10px 12px;
          background-color: rgb(255, 255, 255);
          color: rgb(73, 80, 87);
          font-size: 14px;
          width: 100%;
          height: 55px;
          border: 1px solid #d6d6d6;
          border-radius: 6px;
          font-weight: 500;
          box-shadow: none;
        }
   
      `}</style>
    </>
  );
};

export default BusCharter;
